import { render } from "./AbTests.vue?vue&type=template&id=70c20e33"
import script from "./AbTests.vue?vue&type=script&lang=js"
export * from "./AbTests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__